import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
